import { headerSlotInsetOptions } from '@/components/ui/pageFrame';
import { Stack } from 'expo-router';
import { getTokenValue, YStack } from 'tamagui';

import PSToastHost from '@/components/ui/PSToastHost';

/**
 * Delete-account flow layout — the nested Stack for the `/delete-account/*`
 * modal group.
 *
 * Presented as a sheet over Settings, and as with `/auth/*` the
 * `presentation: 'modal'` that lifts it is declared on the PARENT stack (see the
 * `<Stack.Screen name="delete-account">` entry in app/_layout.tsx) — a nested
 * Stack can't make itself modal. This one owns the flow's internal steps: review
 * what you're about to lose, then type the phrase.
 *
 * Swipe-to-dismiss stays ON, unlike auth: abandoning this flow is a perfectly
 * good outcome, and nothing is half-created if you do.
 *
 * `PSToastHost` is mounted here for the reason auth mounts its own — on iOS this
 * group is a natively-presented sheet and the root layout's host draws
 * UNDERNEATH it, so every toast in the flow would be invisible. The root host
 * un-mounts itself while this group is the active route, so the two never draw
 * the same toast; see [[PSToastHost]] on why a third host can't just be added.
 */
export default function DeleteAccountLayout() {
  return (
    <YStack flex={1}>
      <Stack
        screenOptions={{
          ...headerSlotInsetOptions,
          headerShown: true,
          headerShadowVisible: false,
          headerStyle: {
            backgroundColor: getTokenValue('$color.background'),
          },
          contentStyle: {
            backgroundColor: getTokenValue('$color.background'),
          },
          headerTitle: () => <></>,
          animation: 'slide_from_right',
        }}
      />
      <PSToastHost />
    </YStack>
  );
}
